export const FORM_SELECTED = 'Form selected';
export const GET_PROCESSES_LIST = 'Get processes list';
export const LOADING = 'Loading';


